module.exports = __webpack_public_path__ + "img/c08_buildingtechmarksmanship_Normal_ua.25b0cd93.webp";